import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotFoundComponent } from '@digilize/shared/feature/components/src';

import { LoginModule } from './views/login/login.module';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./views/main.module').then((m) => m.MainModule),
  },
  {
    path: 'auth',
    loadChildren: () => LoginModule, // not lazy loaded as its first view for non logged user
    title: 'seo.title.auth',
  },
  {
    path: 'register',
    loadChildren: () => import('./views/register-email/register-email.module').then((m) => m.RegisterEmailModule),
    title: 'seo.title.register_email',
  },
  {
    path: 'preview',
    loadChildren: () => import('./views/preview/preview.module').then((m) => m.PreviewModule),
    title: 'seo.title.my_questionnaires',
  },
  {
    path: '**',
    component: NotFoundComponent,
    title: 'seo.title.not_found',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollOffset: [0, 70],
      relativeLinkResolution: 'legacy',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
